import React, { useEffect, useState } from 'react';
import logo from './logo.svg';
import './App.css';
import WebglPlayer from './WebglPlayer';

function App() {
  const [data, setData] = useState(null)
  const [config, setConfig] = useState(null)
  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) == variable) {
        return decodeURIComponent(pair[1]);
      }
    }
    console.log('Query variable %s not found', variable);
  }
  useEffect(() => {
    fetch('configurables.json')
      .then(response => response.json())
      .then(data => {
        setConfig(data);
        fetch(getQueryVariable('setting'))
          .then(response => response.json())
          .then(data => setData(data))
      })
  }, [])
  return (data ? <WebglPlayer data={data} config={config} /> : null);
}

export default App;